import { render, staticRenderFns } from "./addDocumentAgencyIssued.vue?vue&type=template&id=651d0a72&scoped=true&"
import script from "./addDocumentAgencyIssued.vue?vue&type=script&lang=js&"
export * from "./addDocumentAgencyIssued.vue?vue&type=script&lang=js&"
import style0 from "./addDocumentAgencyIssued.vue?vue&type=style&index=0&id=651d0a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d0a72",
  null
  
)

export default component.exports